import { routes as registration } from './registration'
import { routes as specialities } from './specialities'

export default [
  ...registration,
  ...specialities
]



// WEBPACK FOOTER //
// ./src/app/professional/record/routes.js